import React from "react";
import { useNavigate } from "react-router-dom";

import { useMediaQuery } from "@mui/material";

import { Container } from "@mui/material";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";

import Breadcrumb from "../breadcrumbs";
import { classes, AppBar } from "./style";

const Header = ({ darkMode, handleThemeToggle }) => {
  const navigate = useNavigate();

  const goHome = async () => {
    navigate({
      pathname: "/",
    });
  };

  const isMobile = useMediaQuery(
    `(max-width:${localStorage.getItem("SM_SCREEN")})`
  );

  return (
    <>
      <AppBar className={classes.header}>
        <Container>
          <Toolbar className={classes.toolbar}>
            <div className={classes.leftSection}>
              <Typography variant="h5" noWrap className={classes.logo}>
                <img
                  src={
                    darkMode
                      ? `${process.env.PUBLIC_URL}/assets/cybera-white-logo.svg`
                      : `${process.env.PUBLIC_URL}/assets/cybera-colour-logo.svg`
                  }
                  alt="Cybera"
                  style={{ height: isMobile ? "40px" : "50px" }}
                  onClick={goHome}
                ></img>
              </Typography>
            </div>
            <div className={classes.rightSection}>
              <IconButton
                style={{ width: "50px" }}
                onClick={() => {
                  handleThemeToggle(!darkMode);
                }}
              >
                {darkMode ? <DarkModeIcon /> : <LightModeIcon />}
              </IconButton>
            </div>
          </Toolbar>
        </Container>
      </AppBar>
      <Breadcrumb />
    </>
  );
};

export default Header;
